import { useOrientation } from '@/hooks/useOrientation';
import styles from './styles.module.scss';
import clsx from 'clsx';
import { useCallback } from 'react';
import { SHOP_SEARCH_MODE } from '@/enums/shop';
import FnbSearchByText from '@/components/feature/fnb/fnb-search/search-by-text';
import FnbSearchByFloor from '@/components/feature/fnb/fnb-search/search-by-floor';
import FnbSearchByCategory from '@/components/feature/fnb/fnb-search/search-by-category';
import FnbSearchControl from '@/components/feature/fnb/fnb-search/search-control';
import { useFnbStore } from '@/stores';

const FnbSearch = () => {
    const { isHorizontal } = useOrientation();
    const currentMode = useFnbStore((state) => state.currentMode);

    const renderContent = useCallback(() => {
        switch (currentMode) {
            case SHOP_SEARCH_MODE.SEARCH_BY_TEXT:
                return <FnbSearchByText />;
            case SHOP_SEARCH_MODE.SEARCH_BY_FLOOR:
                return <FnbSearchByFloor />;
            case SHOP_SEARCH_MODE.SEARCH_BY_CATEGORY:
                return <FnbSearchByCategory />;
            default:
                return <FnbSearchByText />;
        }
    }, [currentMode]);

    return (
        <div
            className={clsx(styles['shop-search'], {
                [styles['shop-search__horizontal']]: isHorizontal,
                [styles['shop-search__vertical']]: !isHorizontal,
            })}
        >
            <div
                className={clsx(styles['shop-search__control'], {
                    [styles['shop-search__control__horizontal']]: isHorizontal,
                    [styles['shop-search__control__vertical']]: !isHorizontal,
                })}
            >
                <FnbSearchControl currentMode={currentMode} />
            </div>
            <div className={styles['shop-search__content']}>{renderContent()}</div>
        </div>
    );
};

export default FnbSearch;
